<template>
	<b-modal ref="mdlRsaPazientePrescrizioneFarmaciEditModalComponent" size="xl" style="height: 100%" no-close-on-backdrop :okDisabled="!isPrescrizioneValida" title="" @ok="onOk" @shown="onShown" @hide="onHideModal" dialog-class="sa-modal-full-height">
		<template #modal-title>Prescrizione Farmaco</template>
		<div class="sa-flexbox-pianificazione-modal">
			<div class="sa-flexbox-pianificazione-modal-header">
				<div class="w-100 text-center mb-2">
					<small v-if="!isPrescrizioneValida" class="text-danger">
						<i class="fas fa-exclamation-triangle"></i>
						Completa tutte le sezioni obbligatorie (segnati in rosso) per proseguire.
					</small>
				</div>
				<div>
					<b-row>
						<b-col cols="12" sm="12" md="4" lg="4" xl="2">
							<label class="sa-label-data">Data Inizio:</label>
							<b-input-group class="mb-3">
								<date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataInizio" type="search"></date-picker>
							</b-input-group>
							<label class="sa-label-data">Data Fine:</label>
							<b-input-group class="mb-3">
								<date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataFine" type="search"></date-picker>
							</b-input-group>
						</b-col>
						<b-col cols="12" sm="12" md="4" lg="4" xl="10">
							<div style="flex: 1; padding-right: 5px; display: flex; flex-direction: column">
								<label class="sa-label-data">Opzioni:</label>
								<b-row style="border: 1px solid rgb(204, 204, 204); width: 100%; height: 100%; margin-left: 0px; padding-top: 20px; padding-bottom: 10px">
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.alBisogno">Al Bisogno</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.salvavita">Salvavita</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.obbligoNota">Obbligo Nota</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.misuraPressione">Misura Pressione</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.misuraGlicemia">Misura Glicemia</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.modificabile">Modificabile</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.caricoPaziente">A carico del paziente/cargiver</b-form-checkbox>
									</b-col>
									<b-col cols="6" xs="12" sm="12" md="1" lg="6" xl="4">
										<b-form-checkbox switch v-model="jsonData.terapiaPsichiatrica">Terapia Psichiatrica</b-form-checkbox>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="sa-flexbox-pianificazione-modal-body">
				<div style="flex: 1">
					<b-tabs v-model="prescrizioneActiveTabIndex" content-class="mt-3 sa-tab-content" class="sa-tab sa-tab-items-vertical" style="height: 100%; padding-bottom: 25px; position: relative; z-index: 0" @input="onInputTabs" vertical>
						<b-tab title="Farmaci" id="tbFarmaci" class="sa-test" :disabled="tadFarmaciDisabled">
							<template #title>
								<span :class="farmaciStatusClass">
									<i class="fas fa-flask"></i>
									<span style="padding-left: 10px">Farmaci</span>
								</span>
							</template>
							<RsaPazientePrescrizioneFarmaciComponent ref="cmpRsaPazientePrescrizioneFarmaciComponent" @confermaPrescrizione="onRsaPazientePrescrizioneFarmaciComponentConfermaPrescrizione" @openRicercaFamraco="onRsaPazientePrescrizioneFarmaciComponentOpenRicercaFamraco" />
						</b-tab>
						<b-tab title="Soluzione" id="tbSoluzione" class="sa-test" :disabled="tadSoluzioniDisabled">
							<template #title>
								<span :class="soluzioneStatusClass">
									<i class="fas fa-flask"></i>
									<span style="padding-left: 10px">Soluzioni</span>
								</span>
							</template>
							<rsa-paziente-prescrizione-soluzione-component
								ref="cmpRsaPazientePrescrizioneSoluzioneComponent"
								@confermaPrescrizione="onRsaPazientePrescrizioneSoluzioneComponentConfermaPrescrizione"
								@openRicercaFamraco="onRsaPazientePrescrizioneSoluzioneComponentOpenRicercaFamraco"
							>
							</rsa-paziente-prescrizione-soluzione-component>
						</b-tab>
						<b-tab title="Elastomero" id="tbElastomero" class="sa-test" :disabled="tadElastomeroDisabled">
							<template #title>
								<span :class="elastomeroStatusClass">
									<i class="fas fa-flask"></i>
									<span style="padding-left: 10px">Elastomero</span>
								</span>
							</template>
							<rsa-paziente-prescrizione-elastomero-component
								ref="cmpRsaPazientePrescrizioneElastomeroComponent"
								@confermaPrescrizione="onRsaPazientePrescrizioneElastomeroComponentConfermaPrescrizione"
								@openRicercaFamraco="onRsaPazientePrescrizioneElastomeroComponentOpenRicercaFamraco"
							>
							</rsa-paziente-prescrizione-elastomero-component>
						</b-tab>
						<b-tab title="Indicazioni" id="tbIndicazioni">
							<template #title> <i class="far fa-sticky-note"></i><span style="padding-left: 10px">Indicazioni</span> </template>
							<div style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; display: flex; flex-direction: column">
								<label class="sa-label-data">Indicazioni:</label>
								<vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.note" />
							</div>
						</b-tab>
						<b-tab title="Pianificazione" id="tbPianificazione">
							<!-- <template #title> <i class="far fa-calendar-alt"></i><span style="padding-left: 10px">Pianificazione</span> </template> -->
							<template #title>
								<span :class="pianificazioneStatusClass">
									<i class="far fa-calendar-alt"></i>
									<span style="padding-left: 10px">Pianificazione</span>
								</span>
							</template>
							<div style="display: block; background-color: transparent">
								<b-tabs id="tbPianificazioneOrari" ref="tbPianificazioneOrari" v-model="tbPianificazioneOrariIndex" content-class="mt-3" class="sa-tab" style="height: 100%" fill>
									<b-tab title="Orario" :disabled="tabOrarioDisabled">
										<rsa-pianificazione-edit-orario ref="cmpRsaPianificazioneEditOrario" @afterMounted="onAfterMountedRsaPianificazioneEditOrario" @updatePianificazioneOrario="onUpdatePianificazioneOrario"></rsa-pianificazione-edit-orario>
									</b-tab>
									<b-tab title="Turni" :disabled="tabTurniDisabled">
										<rsa-pianificazione-edit-turni ref="cmpRsaPianificazioneEditTurni" @afterMounted="onAfterMountedRsaPianificazioneEditTurni" @updatePianificazioneTurni="onUpdatePianificazioneTurni"></rsa-pianificazione-edit-turni>
									</b-tab>
									<b-tab title="Ore Alternate" :disabled="tabOreAlternateDisabled">
										<rsa-pianificazione-edit-ore-alternate
											ref="cmpRsaPianificazioneEditOreAlternate"
											@afterMounted="onAfterMountedRsaPianificazioneEditOreAlternate"
											@updatePianificazioneOreAlternate="onUpdatePianificazioneOreAlternate"
										></rsa-pianificazione-edit-ore-alternate>
									</b-tab>
									<b-tab title="Giorni Alternati" :disabled="tabGiorniAlternatiDisabled">
										<rsa-pianificazione-edit-giorni-alternati
											ref="cmpRsaPianificazioneEditGiorniAlternati"
											@afterMounted="onAfterMountedRsaPianificazioneEditGiorniAlternati"
											@updatePianificazioneGiorniAlternati="onUpdatePianificazioneGiorniAlternati"
										></rsa-pianificazione-edit-giorni-alternati>
									</b-tab>
									<b-tab title="Giorni del Mese" :disabled="tabGiorniMeseDisabled">
										<rsa-pianificazione-edit-giorni-mese ref="cmpRsaPianificazioneEditGiorniMese" @afterMounted="onAfterMountedRsaPianificazioneEditGiorniMese" @updatePianificazioneGiorniMese="onUpdatePianificazioneGiorniMese"></rsa-pianificazione-edit-giorni-mese>
									</b-tab>
									<b-tab title="Accessi" :disabled="tabAccessiDisabled">
										<rsa-pianificazione-edit-accessi ref="cmpRsaPianificazioneEditAccessi" @afterMounted="onAfterMountedRsaPianificazioneEditAccessi" @updatePianificazioneAccessi="onUpdatePianificazioneAccessi"></rsa-pianificazione-edit-accessi>
									</b-tab>
								</b-tabs>
							</div>
						</b-tab>
					</b-tabs>
				</div>
				<rsa-paziente-prescrizione-farmaci-tab-modal-component
					ref="cmpRsaPazientePrescrizioneFarmaciTabModalComponent"
					@confermaSelezione="onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent"
					@annullaSelezione="onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent"
					:datiAccettazione="jsonDataAccettazione"
				></rsa-paziente-prescrizione-farmaci-tab-modal-component>
			</div>
			<div class="sa-flexbox-pianificazione-modal-footer"></div>

			<!-- <banca-farmaci-ricerca-farmaco-component ref="cmpBancaFarmaciRicercaFarmacoComponent" @confermaSelezione="onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent" @annullaSelezione="onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent"></banca-farmaci-ricerca-farmaco-component> -->
		</div>
	</b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import RsaPianificazioneEditAccessi from "../../components/pianificazione/RsaPianificazioneEditAccessi.vue";
import RsaPazientePrescrizioneFarmaciTabModalComponent from "./RsaPazientePrescrizioneFarmaciTabModalComponent.vue";
import RsaPazientePrescrizioneElastomeroComponent from "./RsaPazientePrescrizioneElastomeroComponent.vue";
// import BancaFarmaciRicercaFarmacoComponent from "../../../bancafarmaci/components/BancaFarmaciRicercaFarmacoComponent.vue";
import RsaPianificazioneEditTurni from "../../components/pianificazione/RsaPianificazioneEditTurni.vue";
import RsaPianificazioneEditOrario from "../../components/pianificazione/RsaPianificazioneEditOrario.vue";
import RsaPianificazioneEditOreAlternate from "../../components/pianificazione/RsaPianificazioneEditOreAlternate.vue";
import RsaPianificazioneEditGiorniAlternati from "../../components/pianificazione/RsaPianificazioneEditGiorniAlternati.vue";
import RsaPianificazioneEditGiorniMese from "../../components/pianificazione/RsaPianificazioneEditGiorniMese.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
import RsaPazientePrescrizioneSoluzioneComponent from "./RsaPazientePrescrizioneSoluzioneComponent.vue";
import RsaPazientePrescrizioneFarmaciComponent from "./RsaPazientePrescrizioneFarmaciComponent.vue";
export default {
	mixins: [UtilityMixin, MagazzinoMixins],
	components: {
		DatePicker,
		// BancaFarmaciRicercaFarmacoComponent,
		RsaPianificazioneEditTurni,
		RsaPianificazioneEditOrario,
		RsaPianificazioneEditOreAlternate,
		RsaPianificazioneEditGiorniAlternati,
		RsaPianificazioneEditGiorniMese,
		RsaPazientePrescrizioneFarmaciTabModalComponent,
		RsaPazientePrescrizioneFarmaciComponent,
		RsaPazientePrescrizioneSoluzioneComponent,
		RsaPazientePrescrizioneElastomeroComponent,
		RsaPianificazioneEditAccessi,
	},
	computed: {
		unitaMisuraOptionsComputed() {
			let returnValue = [];
			for (let a of this.magazzinoArticoliUnitaMisuraOptions) {
				if (a.multiplo == 1) {
					returnValue.push({ text: a.descrizioneMultiplo, value: a.codiceMoltiplicatore });
				}
			}
			return returnValue;
		},
		isPrescrizioneValida() {
			const isFarmaciOk = Array.isArray(this.jsonData.prescrizioneFarmaci) && this.jsonData.prescrizioneFarmaci.length > 0;
			const isSoluzioneOk = !this.tadSoluzioniDisabled && this.jsonData.tipo === "SOLUZIONE" && Array.isArray(this.jsonData.prescrizioneFarmaci) && this.jsonData.prescrizioneFarmaci.length > 0;
			const isElastomeroOk = !this.tadElastomeroDisabled && this.jsonData.tipo === "ELASTOMERO" && Array.isArray(this.jsonData.prescrizioneFarmaci) && this.jsonData.prescrizioneFarmaci.length > 0;
			const isPianificazioneOk =
				this.jsonData.programmazioneTipo && this.jsonData.programmazioneTipo.trim() !== "" && this.jsonData.programmazioneGiorni && this.jsonData.programmazioneGiorni.trim() !== "" && this.jsonData.programmazioneOrari && this.jsonData.programmazioneOrari.trim() !== "";
			return (isFarmaciOk || isSoluzioneOk || isElastomeroOk) && isPianificazioneOk;
		},

		pianificazioneStatusClass() {
			const isTipoValid = this.jsonData.programmazioneTipo && this.jsonData.programmazioneTipo.trim() !== "";
			const areGiorniValid = this.jsonData.programmazioneGiorni && this.jsonData.programmazioneGiorni.trim() !== "";
			const areOrariValid = this.jsonData.programmazioneOrari && this.jsonData.programmazioneOrari.trim() !== "";
			const isValid = isTipoValid && areGiorniValid && areOrariValid;
			return isValid ? "sa-tab-success" : "sa-tab-error";
		},
		soluzioneStatusClass() {
			let classe = "";
			if (this.jsonData.tipo?.includes("SOLUZIONE")) {
				if (this.jsonData.prescrizioneFarmaci.length > 0) {
					classe = "sa-tab-success";
				} else {
					classe = "sa-tab-error";
				}
			} else {
				classe = "sa-tab-warning";
			}
			return classe;
		},
		elastomeroStatusClass() {
			let classe = "";
			if (this.jsonData.tipo?.includes("ELASTOMERO")) {
				if (this.jsonData.prescrizioneFarmaci.length > 0) {
					classe = "sa-tab-success";
				} else {
					classe = "sa-tab-error";
				}
			} else {
				classe = "sa-tab-warning";
			}
			return classe;
		},
		farmaciStatusClass() {
			let classe = "";

			if (this.jsonData.tipo?.includes("TERAPIA")) {
				if (this.jsonData.prescrizioneFarmaci.length > 0) {
					classe = "sa-tab-success";
				} else {
					classe = "sa-tab-error";
				}
			} else {
				classe = "sa-tab-warning";
			}
			return classe;
		},
		tadFarmaciDisabled() {
			return this.jsonData.prescrizioneFarmaci.length > 0 && !this.jsonData.tipo?.includes("TERAPIA");
		},
		tadElastomeroDisabled() {
			return this.jsonData.prescrizioneFarmaci.length > 0 && !this.jsonData.tipo?.includes("ELASTOMERO");
		},
		tadSoluzioniDisabled() {
			return this.jsonData.prescrizioneFarmaci.length > 0 && !this.jsonData.tipo?.includes("SOLUZIONE");
		},
	},
	data() {
		return {
			pathResources: "/rsapazienteprescrizioni",
			perPage: 10000,
			prescrizioneActiveTabIndex: 0,
			tbPianificazioneOrariIndex: 0,
			soluzione: false,
			elastomero: false,
			prescrizioneConfermata: false,
			tabOrarioDisabled: false,
			tabTurniDisabled: false,
			tabOreAlternateDisabled: false,
			tabGiorniAlternatiDisabled: false,
			tabGiorniMeseDisabled: false,
			paramsAggiunti: null,
			tabAccessiDisabled: false,
			customToolbar: [
				["bold", "italic", "underline", "strike"], // toggled buttons
				[{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
				[{ color: [] }, { background: [] }], // dropdown with defaults from theme
			],
			umOptions: [
				{ value: "Pz", text: "Pezzi" },
				{ value: "gc", text: "Goccie" },
			],

			jsonData: {
				dataInizio: new Date().getTime(),
				dataFine: null,
				alBisogno: true,
				salvavita: true,
				obbligoNota: true,
				misuraPressione: true,
				misuraGlicemia: true,
				modificabile: true,
				caricoPaziente: true,
				terapiaPsichiatrica: true,
				tipoPrestazione: null,
				note: null,
				programmazioneTipo: null,
				programmazioneTipologia: "",
				programmazioneGiorni: null,
				programmazioneOrari: null,
				prescrizioneFarmaci: [{ codiceProdotto: "", atcGmp: "", prescrizione: "", unitaMisura: "", quantita: null, costo: null, formaFarmaceutica: null }],
			},
			jsonDataAccettazione: {},
			fieldsPrescrizioneFarmaci: [
				{
					label: "#",
					key: "index",
					thStyle: "width: 3rem",
				},
				{
					label: "Codice",
					key: "codiceProdotto",
					thStyle: "width: 5rem",
					sortable: true,
				},
				{
					label: "Nome Farmaco",
					key: "prescrizione",
				},
				{
					label: "Forma Farmaceutica",
					key: "formaFarmaceutica",
				},
				{
					label: "U.M.",
					key: "unitaMisura",
					thStyle: "width: 5rem",
				},
				{
					label: "Dose",
					key: "quantita",
					thStyle: "width: 3rem",
				},
				{
					label: "Note",
					key: "note",
					thStyle: "width: 15rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		show(jsonDataPrescrizione, jsonDataAccettazione) {
			let me = this;
			me.jsonData = jsonDataPrescrizione;
			me.jsonDataAccettazione = jsonDataAccettazione;
			this.setDisableTads(jsonDataAccettazione);
			this.mangazzinoArticoliUnitaMisuraLoadData();
			this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show();
			if (!me.jsonData.id && me.jsonData.id != "-1") {
				me.prescrizioneActiveTabIndex = 0;
			}
		},

		setDisableTads(jsonAccettazione) {
			if (jsonAccettazione.regime === "DOMICILIARE") {
				this.tabOrarioDisabled = false;
				this.tabTurniDisabled = false;
				this.tabOreAlternateDisabled = false;
				this.tabGiorniAlternatiDisabled = false;
				this.tabGiorniMeseDisabled = false;
				this.tabAccessiDisabled = false;
			} else {
				this.tabOrarioDisabled = false;
				this.tabTurniDisabled = false;
				this.tabOreAlternateDisabled = false;
				this.tabGiorniAlternatiDisabled = false;
				this.tabGiorniMeseDisabled = false;
				this.tabAccessiDisabled = false;
			}
		},
		closeRicercaFarmaco() {
			// let me = this;
			document.getElementById("boxSelezionaFarmacoPrescrizione").classList.remove("sa-bancafarmaci-visible");
			document.getElementById("boxSelezionaFarmacoPrescrizione").classList.add("sa-bancafarmaci-hidden");
			//me.disabeConferma = false;
		},
		onClickOpenRicercaFarmaco() {
			this.openRicercaFarmaco();
		},
		openRicercaFarmaco() {
			let me = this;
			document.getElementById("boxSelezionaFarmacoPrescrizione").classList.remove("sa-bancafarmaci-hidden");
			document.getElementById("boxSelezionaFarmacoPrescrizione").classList.add("sa-bancafarmaci-visible");
			me.$refs.cmpRsaPazientePrescrizioneFarmaciTabModalComponent.init(me.jsonDataAccettazione);
			//me.disabeConferma = true;
		},
		onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent() {
			this.closeRicercaFarmaco();
			this.jsonData.tipo = null;
		},
		onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent(schedaFarmaco) {
			if (this.soluzione) {
				this.$refs.cmpRsaPazientePrescrizioneSoluzioneComponent.setSelectionFarmaco(schedaFarmaco);
			} else if (this.elastomero) {
				this.$refs.cmpRsaPazientePrescrizioneElastomeroComponent.setSelectionFarmaco(schedaFarmaco);
			} else {
				this.$refs.cmpRsaPazientePrescrizioneFarmaciComponent.setSelectionFarmaco(schedaFarmaco);
			}
			this.closeRicercaFarmaco();
		},
		onOk(bvModalEvent) {
			let me = this;
			bvModalEvent.preventDefault();
			me.salva();
		},
		onShown() {
			let me = this;
			let pianificazione = { tipo: me.jsonData.programmazioneTipo, giorni: me.jsonData.programmazioneGiorni, orari: me.jsonData.programmazioneOrari, params: "{}" };
			me.$refs.cmpRsaPianificazioneEditGiorniMese.init(me.jsonData);
			me.$refs.cmpRsaPianificazioneEditGiorniAlternati.init(me.jsonData);
			switch (pianificazione.tipo) {
				case "TURNI":
					me.$refs.cmpRsaPianificazioneEditTurni.setPianificazione(pianificazione);
					me.tbPianificazioneOrariIndex = 1;
					break;
				case "ORARIO":
					me.$refs.cmpRsaPianificazioneEditOrario.setPianificazione(pianificazione);
					me.tbPianificazioneOrariIndex = 0;
					break;
				case "ORE ALTERNATE":
					pianificazione.params = JSON.stringify({
						numeroOre: this.jsonData.programmazioneNumeroOre,
						numeroRipetizioni: this.jsonData.programmazioneNumeroRipetizioni,
						oraFineSelezionata: this.jsonData.programmazioneOraFineSelezionata,
						oraInizioSelezionata: this.jsonData.programmazioneOraInizioSelezionata,
					});
					me.$refs.cmpRsaPianificazioneEditOreAlternate.setPianificazione(pianificazione);
					me.tbPianificazioneOrariIndex = 2;
					break;
				case "GIORNI ALTERNATI":
					me.$refs.cmpRsaPianificazioneEditGiorniAlternati.setPianificazione(me.jsonData, pianificazione);
					me.tbPianificazioneOrariIndex = 3;
					break;
				case "GIORNI MESE":
					pianificazione.params = JSON.stringify({
						tipologia: this.jsonData.programmazioneTipologia,
						frequenza: this.jsonData.programmazioneFrequenza,
					});
					me.$refs.cmpRsaPianificazioneEditGiorniMese.setPianificazione(pianificazione);
					me.tbPianificazioneOrariIndex = 4;
					break;
				case "ACCESSI":
					pianificazione.params = JSON.stringify({
						tipologia: this.jsonData.programmazioneTipologia,
					});
					me.$refs.cmpRsaPianificazioneEditAccessi.setPianificazione(pianificazione);
					me.tbPianificazioneOrariIndex = 5;
					break;
			}
			console.log(this.jsonData.id);

			if (this.jsonData.id) {
				if (this.jsonData.tipo == "TERAPIA COMBINATA" || this.jsonData.tipo == "TERAPIA") {
					me.prescrizioneActiveTabIndex = 0;
					this.soluzione = false;
					this.elastomero = false;
					console.log(me.jsonData.prescrizioneFarmaci);

					me.$refs.cmpRsaPazientePrescrizioneFarmaciComponent.setFarmaci(me.jsonData.prescrizioneFarmaci);
				}
				if (me.jsonData.tipo == "SOLUZIONE") {
					me.prescrizioneActiveTabIndex = 1;
					this.soluzione = true;
					this.elastomero = false;
					me.$refs.cmpRsaPazientePrescrizioneSoluzioneComponent.setSoluzione(me.jsonData.prescrizioneFarmaci, me.jsonData.params);
				}
				if (me.jsonData.tipo == "ELASTOMERO") {
					me.prescrizioneActiveTabIndex = 2;
					this.soluzione = false;
					this.elastomero = true;
					me.$refs.cmpRsaPazientePrescrizioneElastomeroComponent.setFarmaciElistomero(me.jsonData.prescrizioneFarmaci, me.jsonData.params);
				}
			}
		},
		onInputTabs() {},
		onUpdateUnitaMisure(item, value) {
			this.jsonData.prescrizioneFarmaci[item.index].unitaMisura = value;
		},
		onUpdateQuantita(item, value) {
			this.jsonData.prescrizioneFarmaci[item.index].quantita = value;
		},
		onUpdateNote(item, value) {
			this.jsonData.prescrizioneFarmaci[item.index].note = value;
		},
		onAfterMountedRsaPianificazioneEditTurni() {},
		onUpdatePianificazioneTurni(params) {
			this.listaOrari = [];
			this.jsonData.programmazioneFrequenza = null;
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = params.orari;
			this.jsonData.programmazioneTipo = "TURNI";
			this.jsonData.programmazioneTipologia = null;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		onAfterMountedRsaPianificazioneEditOrario() {},
		onUpdatePianificazioneOrario(params) {
			this.jsonData.programmazioneFrequenza = null;
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = params.orari;
			this.jsonData.programmazioneTipo = "ORARIO";
			this.jsonData.programmazioneTipologia = null;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		onAfterMountedRsaPianificazioneEditOreAlternate() {},
		onUpdatePianificazioneOreAlternate(params) {
			this.jsonData.programmazioneFrequenza = null;
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = params.orari;
			this.jsonData.programmazioneTipo = "ORE ALTERNATE";
			this.jsonData.programmazioneTipologia = null;
			this.jsonData.programmazioneNumeroOre = params.params.numeroOre;
			this.jsonData.programmazioneNumeroRipetizioni = params.params.numeroRipetizioni;
			this.jsonData.programmazioneOraFineSelezionata = params.params.oraFineSelezionata;
			this.jsonData.programmazioneOraInizioSelezionata = params.params.oraInizioSelezionata;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		onAfterMountedRsaPianificazioneEditGiorniAlternati() {},
		onUpdatePianificazioneGiorniAlternati(params) {
			this.jsonData.programmazioneFrequenza = null;
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = params.orari;
			this.jsonData.programmazioneTipo = "GIORNI ALTERNATI";
			this.jsonData.programmazioneTipologia = null;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		onAfterMountedRsaPianificazioneEditGiorniMese() {},
		onUpdatePianificazioneGiorniMese(params) {
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = params.orari;
			this.jsonData.programmazioneTipo = "GIORNI MESE";
			this.jsonData.programmazioneTipologia = params.params.tipologia;
			this.jsonData.programmazioneFrequenza = params.params.frequenza;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		onAfterMountedRsaPianificazioneEditAccessi() {},
		onUpdatePianificazioneAccessi(params) {
			this.jsonData.programmazioneGiorni = params.giorni;
			this.jsonData.programmazioneOrari = "00:00";
			this.jsonData.programmazioneTipo = "ACCESSI";
			this.jsonData.programmazioneTipologia = params.params.tipologia;
			this.jsonData.params = this.paramsAggiunti == null ? "{}" : `${JSON.stringify(this.paramsAggiunti)}`;
		},
		salva() {
			let saveData = structuredClone(this.jsonData);
			UtilityMixin.methods.saveResource(this.pathResources, saveData, this.salvaSuccess);
		},
		salvaSuccess() {
			let messaggio = "Salvataggio avvenuto con successo";
			this.$bvToast.toast(messaggio, {
				title: "INFO",
				autoHideDelay: 5000,
				variant: "success",
			});
			this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.hide();
			this.$emit("afterSave");
		},
		onHideModal() {
			this.$emit("afterCloseModal");
		},
		onClickEliminaFarmaco(index) {
			this.jsonData.prescrizioneFarmaci.splice(index, 1);
		},
		onRsaPazientePrescrizioneSoluzioneComponentOpenRicercaFamraco() {
			this.soluzione = true;
			this.elastomero = false;
			this.jsonData.tipo = "SOLUZIONE";
			this.openRicercaFarmaco();
		},
		onRsaPazientePrescrizioneElastomeroComponentOpenRicercaFamraco() {
			this.elastomero = true;
			this.soluzione = false;
			this.jsonData.tipo = "ELASTOMERO";
			this.openRicercaFarmaco();
		},
		onRsaPazientePrescrizioneFarmaciComponentOpenRicercaFamraco() {
			this.soluzione = false;
			this.elastomero = false;
			this.jsonData.tipo = "TERAPIA";
			this.openRicercaFarmaco();
		},
		onRsaPazientePrescrizioneSoluzioneComponentConfermaPrescrizione(prescrizioneFarmaci, params) {
			this.setFarmaci(prescrizioneFarmaci);
			this.paramsAggiunti = params;
		},
		onRsaPazientePrescrizioneElastomeroComponentConfermaPrescrizione(prescrizioneFarmaci, params) {
			this.setFarmaci(prescrizioneFarmaci);
			this.paramsAggiunti = params;
		},

		onRsaPazientePrescrizioneFarmaciComponentConfermaPrescrizione(prescrizioneFarmaci) {
			this.setFarmaci(prescrizioneFarmaci);
			this.jsonData.tipo = prescrizioneFarmaci.length == 1 ? "TERAPIA" : "TERAPIA COMBINATA";
		},
		setFarmaci(prescrizioneFarmaci) {
			this.jsonData.prescrizioneFarmaci = JSON.parse(JSON.stringify(prescrizioneFarmaci));
		},
	},
};
</script>

<style scoped>
.sa-tab-success {
	color: #28a745 !important;
	/* Verde Bootstrap */
	font-weight: bold;
}

/* Se vuoi colorare anche l'icona quando la condizione è vera */
.sa-tab-success i {
	color: #28a745 !important;
}

/* Classe per condizione NON verificata (Rosso) */
.sa-tab-error {
	color: #dc3545 !important;
}

.sa-tab-error i {
	color: #dc3545 !important;
}

.sa-tab-warning {
	color: #9b9e00 !important;
	/* Verde Bootstrap */
	font-weight: bold;
}

/* Se vuoi colorare anche l'icona quando la condizione è vera */
.sa-tab-warning i {
	color: #9b9e00 !important;
}
</style>
